(function () {
  // Telemetry section — the section pins in place (see .telemetry-hud__pin's
  // position: sticky in racing-theme-v2.css, and the extra-tall
  // .telemetry-hud__pin-spacer that gives it scroll room to pin against)
  // while scroll progress through that extra height steps through the
  // cards one at a time: each drops onto the stage, then retracts back off
  // before the next one drops in. Scrolling back up walks the same steps in
  // reverse. Once fully stepped through (or back out the top), the page
  // keeps scrolling normally past the section. Kept as the very first
  // script on the page (rather than appended at the end) so it still runs
  // even if an unrelated effect further down the file throws.
  var pins = document.querySelectorAll('[data-telemetry-pin]');
  if (!pins.length) return;

  var rigs = [];
  pins.forEach(function (spacer) {
    var nodes = spacer.querySelectorAll('.telemetry-node');
    if (!nodes.length) return;
    rigs.push({ spacer: spacer, nodes: nodes, lastIndex: -2 });
  });

  if (!rigs.length) return;

  function update() {
    var vh = window.innerHeight;

    rigs.forEach(function (rig) {
      var rect = rig.spacer.getBoundingClientRect();
      var total = rig.nodes.length;
      var activeIndex;

      if (rect.top > 0 || rect.bottom <= vh) {
        // Not yet reached, or already stepped all the way through — no
        // card on stage either side of the pinned range.
        activeIndex = -1;
      } else {
        var scrollable = rig.spacer.offsetHeight - vh;
        var progress = scrollable > 0 ? -rect.top / scrollable : 0;
        progress = Math.max(0, Math.min(1, progress));
        activeIndex = Math.min(total - 1, Math.floor(progress * total));
      }

      if (activeIndex === rig.lastIndex) return;
      rig.lastIndex = activeIndex;

      rig.nodes.forEach(function (node, i) {
        node.classList.toggle('is-visible', i === activeIndex);
      });
    });

    window.requestAnimationFrame(update);
  }

  window.requestAnimationFrame(update);
})();

(function () {
  // Hero + Telemetry (home page) — one long pinned scroll shared by the can
  // spin and the telemetry cards (see .hero-telemetry__pin-spacer / __pin in
  // racing-theme-v2.css, and sections/hero-telemetry.liquid). Both are
  // driven off the exact same 0-1 progress value through the pin's extra
  // scroll height, computed once per rig per frame:
  //   - the can steps through all 30 frames linearly across the *whole*
  //     range, so it's still mid-spin while cards are popping in, not done
  //     spinning before they start.
  //   - the cards pop up one at a time (each at its own fixed position
  //     around the can — see .hero-telemetry__grid's nth-child rules) and
  //     accumulate, all staying visible together once shown — unlike the
  //     plain telemetry rig above, which shows only one at a time. Once
  //     progress reaches 1 (the pin's scroll range is used up), all of them
  //     fade back out together — reusing the same hidden state each starts
  //     from, just reached from "all visible" instead of "none yet".
  var pins = document.querySelectorAll('[data-hero-telemetry-pin]');
  if (!pins.length) return;

  var rigs = [];
  pins.forEach(function (spacer) {
    var canFrames = spacer.querySelectorAll('.hero-telemetry__can-frame');
    var nodes = spacer.querySelectorAll('.telemetry-node');
    if (!canFrames.length && !nodes.length) return;
    rigs.push({
      spacer: spacer,
      canFrames: canFrames,
      nodes: nodes,
      stage: spacer.querySelector('.hero-telemetry__stage'),
      lastCanIndex: -1,
      lastRevealCount: -2
    });
  });

  if (!rigs.length) return;

  function update() {
    var vh = window.innerHeight;

    rigs.forEach(function (rig) {
      var rect = rig.spacer.getBoundingClientRect();
      var scrollable = rig.spacer.offsetHeight - vh;
      var progress;

      if (rect.top > 0) {
        progress = 0;
      } else if (rect.bottom <= vh) {
        progress = 1;
      } else {
        progress = scrollable > 0 ? -rect.top / scrollable : 0;
        progress = Math.max(0, Math.min(1, progress));
      }

      if (rig.canFrames.length) {
        var canIndex = Math.round(progress * (rig.canFrames.length - 1));
        if (canIndex !== rig.lastCanIndex) {
          rig.lastCanIndex = canIndex;
          rig.canFrames.forEach(function (frame, i) {
            frame.classList.toggle('is-active', i === canIndex);
          });
        }
      }

      if (rig.nodes.length) {
        var total = rig.nodes.length;
        var revealCount = rect.top > 0 || rect.bottom <= vh
          ? 0
          : Math.min(total, Math.floor(progress * total) + 1);

        if (revealCount !== rig.lastRevealCount) {
          rig.lastRevealCount = revealCount;
          rig.nodes.forEach(function (node, i) {
            node.classList.toggle('is-visible', i < revealCount);
          });
          // The title/tagline (.hero-telemetry__stage) only has room to read
          // clearly before the first card pops up — fades out the instant
          // revealCount reaches 1, back in if you scroll up past that point.
          if (rig.stage) rig.stage.classList.toggle('is-hidden', revealCount > 0);
        }
      }
    });

    window.requestAnimationFrame(update);
  }

  window.requestAnimationFrame(update);
})();

(function () {
  // Site settings dropdown — lets visitors turn off each effects category.
  // State persists in localStorage and is applied as classes on <html>
  // (fx-sheens-off / fx-wind-off / fx-heat-off / fx-cards-off); the other
  // effect IIFEs below check those classes each time they'd otherwise animate
  // something, so toggling takes effect on the very next scroll/mousemove/
  // keystroke. Turning a category off also immediately resets anything
  // currently mid-effect, instead of waiting for the next event.
  var root = document.documentElement;
  var TOGGLES = ['sheens', 'wind', 'heat', 'cards'];
  var STORAGE_PREFIX = 'car77-fx-';

  function isEnabled(name) {
    var stored = localStorage.getItem(STORAGE_PREFIX + name);
    return stored !== 'off';
  }

  function applyClass(name) {
    root.classList.toggle('fx-' + name + '-off', !isEnabled(name));
  }

  function resetSheens() {
    root.style.setProperty('--clearcoat-x', '0%');
    root.style.setProperty('--redmetal-x', '0%');
    document.querySelectorAll('.rich-text.color-scheme-2').forEach(function (el) {
      el.style.backgroundPosition = '0 0, 0% 50%';
    });
  }

  function resetWind() {
    // The airflow streams are hidden by the .fx-wind-off CSS rule and their
    // rAF loop skips updates per-frame — nothing else to reset. (The hero can
    // scrubber's own scroll stepping is deliberately NOT a wind effect and
    // keeps running.)
  }

  function resetHeat() {
    document.querySelectorAll("input[type='email']").forEach(function (el) {
      el.style.color = '';
      var field = el.closest('.field');
      var label = field ? field.querySelector('.field__label') : null;
      var frame = field ? field.querySelector('.field__heat-frame') : null;
      if (label) label.style.color = '';
      if (frame) {
        frame.classList.remove('is-heated');
        frame.style.removeProperty('--heat-color');
        frame.style.removeProperty('--heat-blur');
      }
    });
  }

  function resetCards() {
    document.querySelectorAll('.livery-slot__inner').forEach(function (el) {
      el.style.transition = 'transform 0.4s ease, box-shadow 0.4s ease, background-color 0.15s ease';
      el.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0px) scale(1)';
      el.style.boxShadow = 'none';
    });
  }

  var resetters = { sheens: resetSheens, wind: resetWind, heat: resetHeat, cards: resetCards };

  TOGGLES.forEach(applyClass);

  // Public hook so other scripts (performance-mode.js's Low RAM tier) can
  // flip these same four categories together without re-implementing the
  // toggle/reset/localStorage logic above. Safe to call before the settings
  // panel below has bound its own checkboxes.
  window.RacingFX = {
    setEnabled: function (name, enabled) {
      if (TOGGLES.indexOf(name) === -1) return;
      localStorage.setItem(STORAGE_PREFIX + name, enabled ? 'on' : 'off');
      applyClass(name);
      if (!enabled) resetters[name]();
    },
    isEnabled: isEnabled
  };

  // "Car 77" (default) vs "Car 39" (teaser flavor) — a much simpler on/off than
  // the effects toggles: one class on <html>, one localStorage key, and the CSS
  // variable overrides in racing-theme.css do the rest.
  var THEME_KEY = 'car77-theme';

  function applyTheme() {
    var theme = localStorage.getItem(THEME_KEY) || 'car77';
    root.classList.toggle('theme-car39', theme === 'car39');
    return theme;
  }

  var currentTheme = applyTheme();

  var panel = document.getElementById('SiteSettingsPanel');
  var toggleButton = document.querySelector('.site-settings__toggle');
  var settingsWrapper = document.querySelector('[data-site-settings]');
  if (!panel || !toggleButton || !settingsWrapper) return;

  // The panel no longer has per-category [data-fx-toggle] checkboxes (see
  // header.liquid's "Performance" section) — window.RacingFX.setEnabled
  // above is now the only way these four categories get flipped, driven by
  // performance-mode.js's Low RAM Mode.

  var themeSelect = panel.querySelector('[data-theme-select]');
  if (themeSelect) {
    themeSelect.value = currentTheme;
    themeSelect.addEventListener('change', function () {
      localStorage.setItem(THEME_KEY, themeSelect.value);
      applyTheme();
    });
  }

  // "Games" — a single settings-panel checkbox (details TBD) that flips one
  // class on <html> and persists in localStorage, same shape as the theme
  // toggle above. Exposed on window so the "Enable Games" button offered
  // after a successful email signup (see racing-theme.js further down) can
  // flip this same flag instead of maintaining its own separate state.
  var GAMES_KEY = 'car77-games-enabled';

  function applyGames() {
    var enabled = localStorage.getItem(GAMES_KEY) === '1';
    root.classList.toggle('games-enabled', enabled);
    // Lets other widgets (e.g. the tire-game HUD) react instantly to the
    // flag changing, from either this checkbox or window.Car77Games.enable()
    // below, without needing a page reload.
    window.dispatchEvent(new CustomEvent('car77:games-changed'));
    return enabled;
  }

  applyGames();

  var gamesToggle = panel.querySelector('[data-games-toggle]');
  if (gamesToggle) {
    gamesToggle.checked = localStorage.getItem(GAMES_KEY) === '1';
    gamesToggle.addEventListener('change', function () {
      localStorage.setItem(GAMES_KEY, gamesToggle.checked ? '1' : '0');
      applyGames();
    });
  }

  window.Car77Games = {
    isEnabled: function () {
      return localStorage.getItem(GAMES_KEY) === '1';
    },
    enable: function () {
      localStorage.setItem(GAMES_KEY, '1');
      applyGames();
      if (gamesToggle) gamesToggle.checked = true;
    }
  };

  toggleButton.addEventListener('click', function () {
    var open = panel.hidden;
    panel.hidden = !open;
    toggleButton.setAttribute('aria-expanded', String(open));
  });

  document.addEventListener('click', function (e) {
    if (!settingsWrapper.contains(e.target)) {
      panel.hidden = true;
      toggleButton.setAttribute('aria-expanded', 'false');
    }
  });
})();

(function () {
  // Hero can rotation — stacked frames (see .hero-can-scrubber in
  // racing-theme.css), played as you scroll down through the hero's own
  // height. The last frame holds once you've scrolled a full hero-height's
  // worth; past that the hero just scrolls out of view normally like any
  // other section — no pinning/scroll-jacking involved. This stepping is NOT
  // a wind effect — it keeps running when Wind Effects is toggled off (only
  // the airflow streams stop).
  //
  // Frame count is read per-hero from the actual rendered <img> count
  // (image-banner.liquid), not hardcoded here, so bumping the frame set's
  // resolution (e.g. 9 frames -> 30) needs no JS change.
  //
  // Scroll position sets a *target* frame, mapped 1:1/linearly to scroll
  // progress (still reaching the last frame exactly when the hero's height
  // has been scrolled, so the animation is always finished by the time it's
  // off screen at normal scroll speeds) — a scroll tick can jump that target
  // several frames at once. Rather than stepping toward it at a fixed rate
  // (which plays back at a constant speed the whole way and then stops dead
  // the instant it lands — still reads as mechanical/choppy), each new
  // target starts an eased tween from wherever the can currently is: full
  // speed immediately (no ease-in ramp-up), decelerating into the new frame,
  // with duration scaled to how many frames it has to cover — so a
  // multi-frame catch-up eases to a smooth stop instead of cutting off
  // abruptly.
  //
  // Same scroll handler also drives a vertical parallax drift (--hero-can-y,
  // read by .hero-can-scrubber's transform in racing-theme.css) — the can
  // rises against the page as you scroll, same idea as the old "77"
  // numeral's bob, just on the can instead.
  var PARALLAX_FACTOR = 0.6;
  var MIN_TWEEN_MS = 260;
  var MAX_TWEEN_MS = 600;
  var MS_PER_FRAME_OF_DISTANCE = 100;
  var heroes = document.querySelectorAll('.banner__media.placeholder');
  if (!heroes.length) return;

  var scrubbers = Array.prototype.map
    .call(heroes, function (hero) {
      var frames = hero.querySelectorAll('.hero-can-scrubber__frame');
      return {
        hero: hero,
        frames: frames,
        frameCount: frames.length,
        height: hero.offsetHeight,
        activeIndex: 0,
        targetIndex: 0,
        displayIndex: 0,
        tweenFrom: 0,
        tweenStart: 0,
        tweenDuration: 0
      };
    })
    .filter(function (s) {
      return s.frames.length;
    });
  if (!scrubbers.length) return;

  function setFrame(s, index) {
    s.frames.forEach(function (frame, i) {
      frame.classList.toggle('is-active', i === index);
    });
    s.activeIndex = index;
  }

  function onScroll() {
    var scrollY = window.scrollY || window.pageYOffset;
    var yOffset = scrollY * PARALLAX_FACTOR;
    scrubbers.forEach(function (s) {
      s.hero.style.setProperty('--hero-can-y', yOffset + 'px');
      var progress = s.height ? scrollY / s.height : 0;
      progress = Math.max(0, Math.min(1, progress));
      var newTarget = Math.min(s.frameCount - 1, Math.max(0, Math.round(progress * (s.frameCount - 1))));
      if (newTarget !== s.targetIndex) {
        var distance = Math.abs(newTarget - s.displayIndex);
        s.tweenFrom = s.displayIndex;
        s.tweenStart = performance.now();
        s.tweenDuration = Math.min(MAX_TWEEN_MS, Math.max(MIN_TWEEN_MS, distance * MS_PER_FRAME_OF_DISTANCE));
        s.targetIndex = newTarget;
      }
    });
  }

  function tick() {
    var now = performance.now();
    scrubbers.forEach(function (s) {
      if (s.displayIndex === s.targetIndex) return;
      var t = s.tweenDuration ? Math.min(1, (now - s.tweenStart) / s.tweenDuration) : 1;
      // Ease-out only (quarter sine) — full speed the instant a new target
      // lands, decelerating into the stop. No ease-in ramp-up at the start.
      var eased = Math.sin((t * Math.PI) / 2);
      s.displayIndex = t >= 1 ? s.targetIndex : s.tweenFrom + (s.targetIndex - s.tweenFrom) * eased;

      var index = Math.round(s.displayIndex);
      if (index !== s.activeIndex) {
        setFrame(s, index);
      }
    });
    window.requestAnimationFrame(tick);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    scrubbers.forEach(function (s) {
      s.height = s.hero.offsetHeight;
    });
  });
  onScroll();
  window.requestAnimationFrame(tick);
})();

function pageScrollPercent() {
  var scrollY = window.scrollY || window.pageYOffset;
  var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  if (maxScroll <= 0) return 0;
  return Math.max(0, Math.min(100, (scrollY / maxScroll) * 100));
}

(function () {
  // Drives every "metallic"/"clearcoat" surface on the site — the carbon-fibre
  // clearcoat sheen (header/footer, secondary buttons, the product-photo frame,
  // the About accordion headers, the hero's aero bar) AND the red-metal flash
  // (primary buttons, sale badges, the About accordion hover/badge state, the
  // product frame's corner triangle) AND the platinum panel ("Who We Are").
  // All three share one eased position value so the "light source" reads as a
  // single thing moving across the whole page, not three unrelated animations.
  // Set on :root as CSS custom properties, not per-element, since some targets
  // are ::after/::before pseudo-elements JS can't select directly — custom
  // properties inherit into pseudo-elements automatically.
  //
  // The raw scroll percentage runs 0% at the top of the page to 100% at the
  // bottom, but the displayed position eases toward that target each frame
  // instead of snapping to it 1:1 — this is what makes the sweep read as
  // slower/calmer instead of tracking the scrollbar instantly. Clearcoat/platinum
  // run right-to-left (100% minus the eased percent) as you scroll down; red-metal
  // runs the opposite way (left-to-right) so it doesn't read as the exact same
  // animation as the clearcoat/platinum sweep.
  var root = document.documentElement;
  var EASE = 0.06;
  var current = 0;
  var target = 0;
  var rafId = null;

  var platinumEls = document.querySelectorAll('.rich-text.color-scheme-2');

  function loop() {
    if (document.documentElement.classList.contains('fx-sheens-off')) {
      rafId = null;
      return;
    }

    current += (target - current) * EASE;
    if (Math.abs(target - current) < 0.05) current = target;

    root.style.setProperty('--clearcoat-x', 100 - current + '%');
    root.style.setProperty('--redmetal-x', 100 - current + '%');
    platinumEls.forEach(function (el) {
      el.style.backgroundPosition = '0 0, ' + (100 - current) + '% 50%';
    });

    if (current !== target) {
      rafId = window.requestAnimationFrame(loop);
    } else {
      rafId = null;
    }
  }

  function onScroll() {
    if (document.documentElement.classList.contains('fx-sheens-off')) return;
    target = pageScrollPercent();
    if (rafId === null) {
      rafId = window.requestAnimationFrame(loop);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  target = pageScrollPercent();
  current = target;
  loop();
})();

(function () {
  // Steam-trading-card-style 3D tilt on the livery-slot grid boxes. Tracks the mouse
  // as it moves across each card and maps its position to a rotateX/rotateY tilt
  // toward the pointer, with a drop-shadow that shifts opposite the tilt to fake
  // an overhead light source. Transition is turned off while actively tracking
  // (so the tilt follows the pointer instantly) and turned back on on mouseleave
  // (so the snap back to flat is smooth, not instant).
  var MAX_TILT = 5;
  var boxes = document.querySelectorAll('[data-livery-slots-grid] .livery-slot');

  boxes.forEach(function (box) {
    var inner = box.querySelector('.livery-slot__inner');
    if (!inner) return;

    box.addEventListener('mousemove', function (e) {
      if (document.documentElement.classList.contains('fx-cards-off')) return;

      var rect = box.getBoundingClientRect();
      var px = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      var py = ((e.clientY - rect.top) / rect.height) * 2 - 1;
      var rotateY = px * MAX_TILT;
      var rotateX = -py * MAX_TILT;
      // Same px/py used for the tilt also drives the metallic flare's position —
      // inverted (mouse right -> flare shifts left), offset from center by up to
      // 50% (halved from 100%, to counteract the larger 440% background-size
      // making the same offset travel further than before).
      var sheenX = 50 + -px * 50;
      var sheenY = 50 + -py * 50;

      inner.style.transition = 'box-shadow 0.15s ease, background-color 0.15s ease';
      inner.style.transform = 'scale(1.04) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';
      inner.style.boxShadow = -rotateY * 2 + 'px ' + (18 + rotateX * 1.5) + 'px 28px -8px rgba(0, 0, 0, 0.6)';
      inner.style.setProperty('--sheen-x', sheenX.toFixed(1) + '%');
      inner.style.setProperty('--sheen-y', sheenY.toFixed(1) + '%');
    });

    box.addEventListener('mouseleave', function () {
      inner.style.transition = 'transform 0.4s ease, box-shadow 0.4s ease, background-color 0.15s ease';
      inner.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0px) scale(1)';
      inner.style.boxShadow = 'none';
    });
  });
})();

(function () {
  // Email input "heat up": a persistent heat level (0-1), not a pure function of
  // current text length — each new character adds one "unit" of heat on top of
  // wherever it already is, and after 2s of no typing it slowly cools back down.
  // Typing again mid-cooldown resumes warming from whatever the partially-cooled
  // level currently is, instead of jumping back to a value based on character
  // count. Sets --heat-color/--heat-blur on the .field__heat-frame overlay (read
  // by the thermalBreathe keyframe in racing-theme.css) — that's a separate
  // element from the real <input> so the glow doesn't disturb the typed email
  // address. The input's own text color (and the field label's color) still
  // warm up directly, since recoloring text doesn't move it.
  var MAX_CHARS = 16;
  var STEP = 1 / MAX_CHARS;
  var IDLE_MS = 2000;
  var DECAY_INTERVAL_MS = 100;
  var DECAY_STEP = STEP / 2; // 3x the original STEP/6 cooldown rate
  // On a dark background: white (cold) -> yellow -> orange (fully heated).
  // On a light/white background, white would disappear, so that progression
  // instead runs black -> orange.
  var STOPS_DARK_BG = [
    [255, 255, 255],
    [255, 214, 64],
    [255, 122, 26]
  ];
  var STOPS_LIGHT_BG = [
    [0, 0, 0],
    [255, 122, 26]
  ];

  function lerpChannel(a, b, t) {
    return Math.round(a + (b - a) * t);
  }

  function makeLerpColor(stops) {
    var segments = stops.length - 1;
    return function (t) {
      var scaled = t * segments;
      var index = Math.min(Math.floor(scaled), segments - 1);
      var localT = scaled - index;
      var from = stops[index];
      var to = stops[index + 1];
      var r = lerpChannel(from[0], to[0], localT);
      var g = lerpChannel(from[1], to[1], localT);
      var b = lerpChannel(from[2], to[2], localT);
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    };
  }

  // Walks up from the field to find the nearest actual (non-transparent)
  // background color and judges it light vs. dark, so the same script picks
  // the right progression whether the field sits in the (light) hero/product
  // page or the (dark) footer, without hardcoding which section is which.
  function isOnLightBackground(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var bg = getComputedStyle(node).backgroundColor;
      var match = bg.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
      if (match && (match[4] === undefined || parseFloat(match[4]) > 0)) {
        var luminance = (0.299 * match[1] + 0.587 * match[2] + 0.114 * match[3]) / 255;
        return luminance > 0.6;
      }
      node = node.parentElement;
    }
    return false;
  }

  document.querySelectorAll("input[type='email']").forEach(function (el) {
    var field = el.closest('.field');
    var label = field ? field.querySelector('.field__label') : null;
    var frame = field ? field.querySelector('.field__heat-frame') : null;
    var lerpColor = makeLerpColor(isOnLightBackground(el) ? STOPS_LIGHT_BG : STOPS_DARK_BG);

    var heat = 0;
    var lastLength = el.value.length;
    var idleTimer = null;
    var decayTimer = null;

    // --heat-level (0%-100%) is a *direct* function of character count, not
    // the decaying "heat" value below — most fields only use that heat value
    // for the color/glow, which does cool back down while idle, but
    // --heat-level is for any field (like the hero's carbon-fill email box)
    // that wants a fill tied strictly to how much you've typed: it grows and
    // shrinks immediately as characters are added/removed, never decays
    // while the count stays the same, and jumps straight to the right
    // amount on autofill/paste (see the animationstart listener below —
    // autofill doesn't reliably fire 'input' on its own).
    function updateFillLevel() {
      if (!frame) return;
      var pct = Math.min(1, el.value.length / MAX_CHARS);
      frame.style.setProperty('--heat-level', Math.round(pct * 100) + '%');
    }

    function render() {
      if (heat <= 0) {
        heat = 0;
        if (frame) {
          frame.classList.remove('is-heated');
          frame.style.removeProperty('--heat-color');
          frame.style.removeProperty('--heat-blur');
        }
        el.style.color = '';
        if (label) label.style.color = '';
        return;
      }

      var color = lerpColor(heat);
      // Eased (not linear) so the glow starts subtle and ramps up faster as
      // it approaches full heat, instead of growing at a constant rate.
      var blur = 4 + Math.pow(heat, 1.6) * 26;

      if (frame) {
        frame.classList.add('is-heated');
        frame.style.setProperty('--heat-color', color);
        frame.style.setProperty('--heat-blur', blur + 'px');
      }
      el.style.color = color;
      if (label) label.style.color = color;
    }

    function stopDecay() {
      if (decayTimer) {
        clearInterval(decayTimer);
        decayTimer = null;
      }
    }

    function startDecay() {
      stopDecay();
      decayTimer = setInterval(function () {
        heat = Math.max(0, heat - DECAY_STEP);
        render();
        if (heat <= 0) stopDecay();
      }, DECAY_INTERVAL_MS);
    }

    function scheduleIdleDecay() {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(startDecay, IDLE_MS);
    }

    el.addEventListener('input', function () {
      if (document.documentElement.classList.contains('fx-heat-off')) return;

      var n = el.value.length;
      updateFillLevel();

      if (n === 0) {
        heat = 0;
        stopDecay();
        if (idleTimer) clearTimeout(idleTimer);
        render();
        lastLength = 0;
        return;
      }

      if (n > lastLength) {
        // Character(s) added — warm up from wherever heat currently is
        // (mid-cooldown or not), then replay the text jolt. Scaled by how
        // many characters actually landed in this one event (not a flat
        // step), so a paste/autofill of 16+ characters maxes out the heat
        // immediately instead of only counting as a single keystroke.
        stopDecay();
        heat = Math.min(heat + (n - lastLength) * STEP, 1);

        el.classList.remove('is-jolting');
        void el.offsetWidth;
        el.classList.add('is-jolting');
      }
      lastLength = n;

      render();
      scheduleIdleDecay();
    });

    // Autofill doesn't reliably fire 'input' (Chrome/Safari in particular),
    // so the fill level would otherwise stay at 0% for an autofilled
    // address. Standard detection trick: a near-instant CSS animation only
    // matches :-webkit-autofill (see racing-theme-v2.css), and firing it is
    // itself observable as an animationstart event.
    el.addEventListener('animationstart', function (e) {
      if (e.animationName === 'car77AutofillDetect') updateFillLevel();
    });

    // The idle placeholder/label is a bit of flavor text ("icrash@monza.
    // turn1") — clear once you're actually about to type, so it reads as a
    // plain "Email" field instead. Reverts back on blur if left empty.
    var restingPlaceholder = el.getAttribute('placeholder');
    var restingLabel = label ? label.textContent : null;

    el.addEventListener('focus', function () {
      el.setAttribute('placeholder', 'Email');
      if (label) label.textContent = 'Email';
    });

    el.addEventListener('blur', function () {
      el.setAttribute('placeholder', restingPlaceholder);
      if (label) label.textContent = restingLabel;
    });
  });
})();

(function () {
  // Home page hero + Car 77 product page only (this snippet's own
  // .coming-soon-interest__success message — the footer's separate
  // newsletter form is unaffected): once subscribed, stays subscribed on
  // every future visit. form.posted_successfully? only tells the template
  // about the ONE page load right after a real submit (see the hidden
  // [data-just-subscribed] marker rendered then), so that's captured into
  // a localStorage flag, keyed per product, that every later visit checks.
  document.querySelectorAll('[data-coming-soon-interest]').forEach(function (wrapper) {
    var key = 'car77-subscribed-' + wrapper.getAttribute('data-product-key');
    var justSubscribed = !!wrapper.querySelector('[data-just-subscribed]');

    if (justSubscribed) localStorage.setItem(key, '1');

    if (justSubscribed || localStorage.getItem(key) === '1') {
      wrapper.classList.add('coming-soon-interest--subscribed');
    }
  });
})();

(function () {
  // Dev-only shortcut: typing "spaday" into an email field and submitting
  // fakes the success state entirely client-side (no request sent), so the
  // signup flow can be tested without a real email or tripping Shopify's
  // real customer-creation flow. Real emails are completely unaffected —
  // this only intercepts that exact value. For the coming-soon-interest
  // forms this just flips on the same --subscribed class the real flow
  // uses (the success message markup already exists in the DOM, only
  // hidden); the footer's plainer form gets a minimal fake success message
  // instead.
  var DEV_BYPASS_VALUE = 'spaday';

  document.querySelectorAll('form.newsletter-form').forEach(function (form) {
    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;

    // type="email" native validation would otherwise block the submit
    // event entirely before it ever reaches JS, since "spaday" isn't a
    // valid email shape — toggle novalidate off only while the field holds
    // exactly that value, so real emails still get normal validation.
    emailInput.addEventListener('input', function () {
      form.noValidate = emailInput.value.trim().toLowerCase() === DEV_BYPASS_VALUE;
    });

    form.addEventListener('submit', function (e) {
      if (emailInput.value.trim().toLowerCase() !== DEV_BYPASS_VALUE) return;

      e.preventDefault();

      var comingSoonWrapper = form.closest('[data-coming-soon-interest]');
      if (comingSoonWrapper) {
        comingSoonWrapper.classList.add('coming-soon-interest--subscribed');
        return;
      }

      if (form.querySelector('.newsletter-form__message--success')) return;

      var message = document.createElement('h3');
      message.className = 'newsletter-form__message newsletter-form__message--success form__message';
      message.setAttribute('tabindex', '-1');
      message.textContent = 'Email confirmed';
      form.appendChild(message);
      message.focus();
    });
  });
})();

(function () {
  // Wind-tunnel airflow streams, scoped to the can backdrop only — the old
  // hero placeholder and/or the merged Hero + Telemetry section's own can
  // layer. A container + six lines are created here (no Liquid changes
  // needed) and driven by one rAF loop with transform-only writes so each
  // stream stays on its own compositor layer. Live scroll velocity (px/frame,
  // smoothed) feeds a boost multiplier, so flicking the page makes the
  // streams visibly rocket, then settle back to an ambient drift. Respects
  // the "Wind Effects" setting per-frame.
  var hosts = document.querySelectorAll('.banner__media.placeholder, .hero-telemetry__can');
  var root = document.documentElement;
  if (!hosts.length) return;

  var LINE_COUNT = 6;
  // Each line gets a depth (0 = far, 1 = near), scaling drift speed (near air
  // moves faster past you) and the CSS side's thinning/blurring of far
  // layers. Used to also drive a vertical scroll-parallax offset, but that
  // assumed the host scrolled by in normal document flow — inside the merged
  // Hero + Telemetry section the can is pinned (position: sticky), so raw
  // page scrollY kept climbing while the can visually stayed put, dragging
  // the streams downward the whole time it was pinned. Streams are purely
  // horizontal now, matching what "wind" actually looks like regardless of
  // whether the host is pinned or scrolling normally.
  var DEPTHS = [0.25, 0.85, 0.45, 1, 0.35, 0.65];

  var rigs = Array.prototype.map.call(hosts, function (hero) {
    var airflow = document.createElement('div');
    airflow.className = 'car77-airflow';
    airflow.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < LINE_COUNT; i++) {
      var line = document.createElement('span');
      line.className = 'car77-airflow__line';
      airflow.appendChild(line);
    }
    hero.appendChild(airflow);

    var states = Array.prototype.map.call(airflow.children, function (line, i) {
      return {
        el: line,
        // Spread starting positions across the full travel range so the streams
        // don't launch in formation on page load.
        x: (i / LINE_COUNT) * (hero.offsetWidth + 600) - 300,
        depth: DEPTHS[i % DEPTHS.length],
        base: (1.2 + (i % 3) * 0.9) * (0.5 + DEPTHS[i % DEPTHS.length])
      };
    });

    return { hero: hero, states: states };
  });

  var lastScrollY = window.scrollY || window.pageYOffset;
  var velocity = 0;

  function frame() {
    var scrollY = window.scrollY || window.pageYOffset;
    // Smoothed |scroll delta| per frame — decays back toward 0 when idle.
    velocity = velocity * 0.9 + Math.abs(scrollY - lastScrollY) * 0.1;
    lastScrollY = scrollY;

    if (!root.classList.contains('fx-wind-off')) {
      var boost = 1 + Math.min(velocity / 6, 8);
      rigs.forEach(function (rig) {
        var width = rig.hero.offsetWidth;
        var span = width + 600;
        rig.states.forEach(function (s) {
          s.x += s.base * boost;
          if (s.x > width + 300) s.x -= span;
          s.el.style.transform = 'translate3d(' + s.x.toFixed(1) + 'px, 0, 0)';
        });
      });
    }

    window.requestAnimationFrame(frame);
  }

  window.requestAnimationFrame(frame);
})();

(function () {
  // Hero "I'm interested" checkbox: the surrounding content stays bottom-
  // anchored (desktop_content_position: bottom-center), so growing the reveal
  // in place would push the heading/buttons upward instead of the page down.
  // Instead, measure how much taller the widget gets and add that as real
  // padding-bottom on the .banner section itself — that's normal document
  // flow, so it actually pushes "Who We Are" down, while the bottom-anchored
  // content just settles into the extra room the section gained.
  document.querySelectorAll('.coming-soon-interest__checkbox').forEach(function (checkbox) {
    var wrapper = checkbox.closest('.coming-soon-interest');
    var banner = checkbox.closest('.banner');
    if (!wrapper || !banner) return;

    var baseHeight = wrapper.offsetHeight;
    banner.style.transition = 'padding-bottom 0.25s ease';

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        var grown = wrapper.scrollHeight - baseHeight;
        banner.style.paddingBottom = Math.max(grown, 0) + 'px';
      } else {
        banner.style.paddingBottom = '';
      }
    });
  });
})();

(function () {
  // Sticker cards (Stage 1: The Team Livery): the whole card is a link to
  // the product page, enhanced here so a click also flashes the headlight
  // LEDs at full brightness and fires a real add-to-cart request (POST
  // /cart/add.js), before carrying the visitor on to product.url. The card
  // stays "locked" for the session (sessionStorage, keyed per product) so a
  // repeat visit just navigates straight through without re-adding.
  // Sold-out cards (data-available="false") are left alone entirely — plain
  // navigation, no cart request.
  var cards = document.querySelectorAll('[data-sticker-card]');
  if (!cards.length) return;

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).catch(function () {
      // Best-effort — the visitor is heading to the product page regardless,
      // where they can add it manually if this request failed.
    });
  }

  function lockCard(card, skipEffects) {
    card.classList.add('sticker-card--locked');
    if (skipEffects) return;
    sessionStorage.setItem('car77-rig-' + card.getAttribute('data-led-key'), '1');
  }

  cards.forEach(function (card) {
    if (sessionStorage.getItem('car77-rig-' + card.getAttribute('data-led-key'))) {
      lockCard(card, true);
    }

    card.addEventListener('click', function (e) {
      // Already added this session, sold out, or coming soon: just navigate
      // normally to the product page (no add-to-cart).
      if (card.classList.contains('sticker-card--locked')) return;
      if (card.getAttribute('data-available') === 'false') return;
      if (card.getAttribute('data-coming-soon') === 'true') return;

      e.preventDefault();

      card.classList.add('sticker-card--flash');
      addToCart(card.getAttribute('data-variant-id'));

      setTimeout(function () {
        card.classList.remove('sticker-card--flash');
        lockCard(card);
        window.location.href = card.href;
      }, 500);
    });
  });
})();

(function () {
  // Car 77 product page — the same 30-frame can rotation as the homepage
  // hero, but driven by cursor position instead of scroll (there's no
  // hero-height scroll range on the product page to drive it). The right
  // edge of the media frame is frame 1; moving the cursor left steps
  // through the rest of the rotation.
  //
  // Tracked via a single document-level mousemove (not a listener scoped to
  // the spinner element) so the frame is already correct the instant the
  // cursor re-enters the zone, instead of lagging behind until the first
  // move inside it. The frame only actually changes while the cursor's
  // current position falls within the spinner's own bounding rect ("the
  // zone") — outside it, whatever frame was last showing just stays put
  // (no reset), so scrolling away and back leaves the can how you left it.
  var spinners = document.querySelectorAll('.product-can-spin');
  if (!spinners.length) return;

  var rigs = Array.prototype.map.call(spinners, function (spinner) {
    var frames = spinner.querySelectorAll('.hero-can-scrubber__frame');
    return { spinner: spinner, frames: frames, activeIndex: 0 };
  }).filter(function (rig) {
    return rig.frames.length;
  });
  if (!rigs.length) return;

  function setFrame(rig, index) {
    if (index === rig.activeIndex) return;
    rig.frames.forEach(function (frame, i) {
      frame.classList.toggle('is-active', i === index);
    });
    rig.activeIndex = index;
  }

  document.addEventListener('mousemove', function (e) {
    rigs.forEach(function (rig) {
      var rect = rig.spinner.getBoundingClientRect();
      var inZone =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;
      if (!inZone) return;

      var relativeX = (e.clientX - rect.left) / rect.width;
      relativeX = Math.max(0, Math.min(1, relativeX));
      // Right edge (relativeX = 1) -> frame 1 (index 0); left edge -> last frame.
      var index = Math.round((1 - relativeX) * (rig.frames.length - 1));
      setFrame(rig, index);
    });
  });
})();

(function () {
  // Car 77 product page can — a localized scroll parallax, same spirit as
  // the hero's --hero-can-y drift but relative to the element's own position
  // in the viewport (not raw page scrollY) since this sits mid-page rather
  // than pinned at the top: as the can scrolls through the viewport it drifts
  // gently opposite the scroll direction, centered on zero when the can is
  // vertically centered on screen. Not a wind effect — keeps running with
  // Wind Effects off, like the hero can's own parallax does.
  var PARALLAX_FACTOR = 0.15;
  var spinners = document.querySelectorAll('.product-can-spin');
  if (!spinners.length) return;

  function update() {
    spinners.forEach(function (spinner) {
      var rect = spinner.getBoundingClientRect();
      var elementCenter = rect.top + rect.height / 2;
      var viewportCenter = window.innerHeight / 2;
      var offset = (viewportCenter - elementCenter) * PARALLAX_FACTOR;
      spinner.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });
    window.requestAnimationFrame(update);
  }

  window.requestAnimationFrame(update);
})();
